import { EndpointBuilder } from "@reduxjs/toolkit/query";
import { FetchArgs, FetchBaseQueryError, FetchBaseQueryMeta } from "@reduxjs/toolkit/query";
import { BaseQueryFn } from "@reduxjs/toolkit/query";
import { SummaryAPIResponse } from "../types";

export const summaryEndPoints = (
  builder: EndpointBuilder<
    BaseQueryFn<
      string | FetchArgs,
      unknown,
      FetchBaseQueryError,
      NonNullable<unknown>,
      FetchBaseQueryMeta
    >,
    string,
    "veeApi"
  >
) => ({
  getGeneralSummaryData: builder.query<SummaryAPIResponse, { pathname: string; searchQuery: string }>({
    query: ({ pathname, searchQuery }) => ({
      url: `/summary/${pathname}_summary${searchQuery}`,
      method: "GET",
    })
  }),
});
